import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetDischargesKpiRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilityId: z.number().optional(),
});

const GetDischargesKpiResponseDtoSchema = z.object({
  count: z.number(),
  changePct: z.number().nullable(),
});

export type GetDischargesKpiRequestDto = z.infer<
  typeof GetDischargesKpiRequestDtoSchema
>;
export type GetDischargesKpiResponseDto = z.infer<
  typeof GetDischargesKpiResponseDtoSchema
>;

export const getDischargesKpi = (
  params: GetDischargesKpiRequestDto,
  config?: AxiosRequestConfig<GetDischargesKpiRequestDto>
) => {
  const validatedParams = GetDischargesKpiRequestDtoSchema.parse(params);
  return api
    .get('/residents/discharges', {
      params: validatedParams,
      ...config,
    })
    .then(responseContract(GetDischargesKpiResponseDtoSchema));
};
